import pairingErrors from '../../consts/device/pairingErrors';

export default class DeviceRequestTimeoutError extends Error {
    constructor(message = 'DeviceRequestTimeoutError', ...args) {
        super(message, ...args);
        this.message = message;
        this.code = pairingErrors.ERROR_CONNECTION_NOT_FOUND.type;
    }
}
